export enum PaymentMethod {
  ONLINE = 'ONLINE',
  SBP = 'SBP',
  CARD = 'CARD',
  BALANCE = 'BALANCE',
}
